<div class="lm-box error-box">
  <div>
    <img src="./assets/sad-monkey-face-hi.png" />
  </div>
  <div>
    <h1>{{ code }}</h1>
    <div class="note">{{ codeNote[code] }}</div>
    <button color="primary" mat-raised-button [routerLink]="getEnvHome()">HOME</button>
  </div>
</div>
